import type { Dispatch } from 'react';

import { motion } from 'motion/react';

import { useTranslate } from '@i18n';

import { u } from '../../styles/unit';
import { Box, Inline } from '../Layout';
import { Heading3 } from '../Text';

import * as css from './ClubSelectionTabs.css';

const MotionBox = motion.create(Box);

type ClubSelectionTabsProps = {
    displayMode: string;
    onSelect: Dispatch<'all' | 'bag'>;
};

export const ClubSelectionTabs = ({ displayMode, onSelect }: ClubSelectionTabsProps) => {
    const t = useTranslate();

    return (
        <Inline bg="panel" radius="pill" p={u(1)} width="fit-content" alignSelf="center">
            <button className={css.toggleItem} onClick={() => onSelect('all')} key="all">
                <Heading3 weight={700} className={css.toggleText({ variant: displayMode === 'all' })}>
                    {t('club_selection.all_clubs')}
                </Heading3>
                {displayMode === 'all' ? <MotionBox className={css.toggleIndicator} layoutId="active" /> : null}
            </button>
            <button className={css.toggleItem} onClick={() => onSelect('bag')} key="bag">
                <Heading3 weight={700} className={css.toggleText({ variant: displayMode === 'bag' })}>
                    {t('club_selection.my_golf_bag')}
                </Heading3>
                {displayMode === 'bag' ? <MotionBox className={css.toggleIndicator} layoutId="active" /> : null}
            </button>
        </Inline>
    );
};
